/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteSubHeader_ProjectFragmentDoc, QuoteSubHeader_QuoteFragmentDoc } from '../../features/quotes/QuoteSubHeader.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectQuoteChangeLogQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
}>;


export type ProjectQuoteChangeLogQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string } | null }, quote: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteResult', quote?: { __typename: 'Quote', id: string, title: string, viewerPermissions: Array<Types.PermissionName>, owningSystemOrganisationId: string, number: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, canBeDeleted: boolean, templateOriginQuoteId?: string | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null }, documents: Array<{ __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } }>, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | null } };


export const ProjectQuoteChangeLogDocument = gql`
    query ProjectQuoteChangeLog($projectId: ID!, $docId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        ...QuoteSubHeader_Project
      }
    }
  }
  quote(projectId: $projectId, docId: $docId) {
    ... on QuoteResult {
      quote {
        id
        title
        ...QuoteSubHeader_Quote
      }
    }
  }
}
    ${QuoteSubHeader_ProjectFragmentDoc}
${QuoteSubHeader_QuoteFragmentDoc}`;

/**
 * __useProjectQuoteChangeLogQuery__
 *
 * To run a query within a React component, call `useProjectQuoteChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuoteChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuoteChangeLogQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useProjectQuoteChangeLogQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables> & ({ variables: ProjectQuoteChangeLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>(ProjectQuoteChangeLogDocument, options);
      }
export function useProjectQuoteChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>(ProjectQuoteChangeLogDocument, options);
        }
export function useProjectQuoteChangeLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>(ProjectQuoteChangeLogDocument, options);
        }
export type ProjectQuoteChangeLogQueryHookResult = ReturnType<typeof useProjectQuoteChangeLogQuery>;
export type ProjectQuoteChangeLogLazyQueryHookResult = ReturnType<typeof useProjectQuoteChangeLogLazyQuery>;
export type ProjectQuoteChangeLogSuspenseQueryHookResult = ReturnType<typeof useProjectQuoteChangeLogSuspenseQuery>;
export type ProjectQuoteChangeLogQueryResult = Apollo.QueryResult<ProjectQuoteChangeLogQuery, ProjectQuoteChangeLogQueryVariables>;